import { ProfilePropertyBlacklist } from 'customer-data-objects/model/PropertyModel';
export const isVisibleProperty = property => {
  return !property.deleted && !property.hidden && !(ProfilePropertyBlacklist.contains(property.name) && property.hubspotDefined);
};